<template>
  <div>
    <aside v-if="atualizacao" class="atualizacao-app" role="status">Uma atualização do Paylogos está disponível. <button @click="atualizarApp">Atualizar aplicativo</button></aside>
    <p v-if="erro" role="alert">{{ erro }}</p>
    <AppLoader v-if="appIsLoading" />
    <router-view/>
  </div>
</template>

<script>
import moment from "moment";
import { mapActions } from "vuex";
import JwtService from "@/store/jwt.service";
import AppLoader from "@/components/AppLoader.vue";

export default {
  name: "App", 
  data() {
    return {
      appIsLoading: true, atualizacao: null, erro: ""
    };
  },
  components: {
    AppLoader
  },
  async mounted() {
    moment.locale('pt-br');
    this.atualizacao = window.paylogosUpdate || null;
    window.addEventListener('paylogos-update', this.novaVersao);
    try {
      if (JwtService.getToken()) {
        const validacao = await this.getValidateToken();
        if (!validacao.resultado) {
          this.logout();
          if (this.$route.meta.requiresAuth) {
            if (this.$route.name === 'pendencia') sessionStorage.setItem('pay-retorno-login', this.$route.fullPath);
            this.$router.push({ name: 'login' });
          }
        }
      }
    } catch { this.erro = 'Não foi possível atualizar sua sessão. Verifique a conexão e tente novamente.'; }
    finally { this.appIsLoading = false; }
  },
  beforeUnmount() { window.removeEventListener('paylogos-update', this.novaVersao); },
  methods: {
    novaVersao(e) { this.atualizacao = e.detail; },
    atualizarApp() {
      if (!this.atualizacao?.waiting) { window.location.reload(); return; }
      navigator.serviceWorker.addEventListener('controllerchange', () => window.location.reload(), { once: true });
      this.atualizacao.waiting.postMessage({ type: 'SKIP_WAITING' });
    },
    ...mapActions(["getValidateToken", "logout"])
  }
}
</script>

<style lang="scss">
  .atualizacao-app { padding: 12px; background: #fff3cd; position: sticky; top: 0; z-index: 100000; }
  .swal2-container {
    z-index: 99999
  }
</style>
